// extracted by mini-css-extract-plugin
export default {"container":"OnboardingLogout_container__CnvQW","email":"OnboardingLogout_email__tfxEa","button":"OnboardingLogout_button__hPBjb"};